<form (ngSubmit)="onSearch(formObj)" #formObj="ngForm" id="gtm-search-refine-form">
    <input type="search" id="searchInput" name="q" class="selenium-search-input" ngModel />
    <button class="btn btn-primary selenium-search-button" type="submit">
        Search
        <i class="fa fa-search"></i>
    </button>
</form>
